import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    EstimatedTradeCostOptimization,
    getInitialEstimatedTradeCostConfigState,
} from 'widgets/estimatedTradeCost/widget/store/EstimatedTradeCostConfigState';

export type EstimatedTradeCostComparisonWidgetSettingsState = {
    config: { optimizations: Array<EstimatedTradeCostOptimization> };
};

const initialState: EstimatedTradeCostComparisonWidgetSettingsState = {
    config: { optimizations: [] },
};

const slice = createSlice({
    name: 'EstimatedTradeCostComparisonWidgetSettingsSlice',
    initialState,
    reducers: {
        addRow: (state) => {
            state.config.optimizations.push(
                getInitialEstimatedTradeCostConfigState()
            );
        },
        removeRow: (state, action: PayloadAction<{ index: number }>) => {
            const {
                payload: { index },
            } = action;

            state.config.optimizations.splice(index, 1);
        },
        updateRow: (
            state,
            action: PayloadAction<{
                index: number;
                delta: Partial<EstimatedTradeCostOptimization>;
            }>
        ) => {
            const {
                payload: { index, delta },
            } = action;

            state.config.optimizations[index] = {
                ...state.config.optimizations[index],
                ...delta,
            };
        },
    },
});

export const actions = slice.actions;

export default slice.reducer;
